/** @class TableResponsiveMixin */

/** @method */
export var TableResponsiveMixin = function TableResponsiveMixin() {
  return "\n    /* On smaller screens, enable horizontal scroll */\n    overflow-x: auto;\n";
};